import {
  CaretDownFilled,
  CaretUpFilled,
  PaperClipOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Collapse,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Typography,
  theme,
} from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useState } from "react";
import Heading from "../../../../../components/common/heading";
import { formatDateBE } from "../../../../../lib/utils/date";

const { useToken } = theme;

const { Title } = Typography;
const dateFormat = "DD/MM/YYYY";
const { RangePicker } = DatePicker;
const { Text, Link } = Typography;
const { Option } = Select;
const { TextArea } = Input;
const { Panel } = Collapse;
export const convertMasterData = (keytext, data) => {
  let text = "";
  data.map((Item) => {
    if (Item.dataId === keytext) {
      text = Item.dataDetailTh;
    }
  });
  console.log(text)
  return text;
};
const ContactView = (props) => {
  const { futureCustomerContacts, DownloadFile,dropDownCurerntStatus,dropDownCurerntStatus_v2 } = props;
  const { token } = useToken();
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const [elems, setElems] = useState([]);
  const [file, setFile] = useState("");
  const [errMgeFile, setErrMgeFile] = useState("");
  const [defaultFile, setDefaultFile] = useState([
    { uid: "", name: "ยังไม่ได้เลือกไฟล์" },
  ]);
  const [positionCollapse, setPositionCollapse] = useState(undefined);
  const [noAction, setNoAction] = useState(true); // for check 1st when come in this page

  const convertToDate = (dateString) => {
    const [day, month, year] = dateString.split('/');

    return new Date(year, month - 1, day)
  };

  const sortByCustomerContactDateDesc = (a, b) => {
    const dateB = convertToDate(b.contactDate);
    const dateA = convertToDate(a.contactDate);

    return dateB - dateA;
  }

  return (
    <Content style={{ paddingTop: 15 }}>
      <Row
        gutter={[16, 8]}
        className="card addElement"
        style={{ marginTop: 30, marginBottom: 50 }}
      >
        <Col span={24}>
          <Heading
            text={"สรุปการติดต่อรายครั้ง"}
            size={4}
            style={{ margin: 0, color: token.thPrimary }}
          />
          <Divider />
        </Col>

        {futureCustomerContacts.length > 0 &&
          [...futureCustomerContacts]
            .sort(sortByCustomerContactDateDesc)
            .map((item, k) => {
              return (
                <Col key={k} span={24}>
                  <div
                    className={`relative`}
                    style={{
                      padding: 15,
                      marginBottom: 20,
                      width: "80%",
                      border: "1px solid #E5EAEE",
                      borderRadius: 10,
                    }}
                  >
                    <Row
                      gutter={[16, 8]}
                      style={{
                        height: noAction ? 80 : positionCollapse === k ? 80 : "",
                        overflow: noAction
                          ? "hidden"
                          : positionCollapse === k
                            ? "hidden"
                            : "",
                      }}
                    >
                      <div className="view-future-collapse-btn">
                        <Button
                          shape="circle"
                          size="small"
                          style={{
                            backgroundColor: "#F4F6FC",
                            border: 0,
                            marginLeft: 5,
                          }}
                          onClick={() => {
                            k !== positionCollapse
                              ? setPositionCollapse(k)
                              : setPositionCollapse(undefined);
                            setNoAction(false);
                          }}
                        >
                          {!noAction && k !== positionCollapse ? (
                            <CaretUpFilled
                              style={{
                                color: "#2E90FA",
                                fontSize: 16,
                              }}
                            />
                          ) : (
                            <CaretDownFilled
                              style={{
                                color: "#2E90FA",
                                fontSize: 16,
                              }}
                            />
                          )}
                        </Button>
                      </div>
                      <Col span={24}>
                        <Row gutter={[8, 16]}>
                          <Col span={4}>
                            <Form.Item
                              label={
                                <Text className="pr_green">
                                  การติดต่อครั้งที่
                                </Text>
                              }
                              name={"date"}
                            >
                              <Text>{futureCustomerContacts.length - k}</Text>
                            </Form.Item>
                          </Col>
                          <Col span={8}>
                            <Form.Item
                              label={
                                <Text className="pr_green">
                                  วัน/เดือน/ปี ที่รับลูกค้า
                                </Text>
                              }
                              name={"date"}
                            >
                              <Text>
                                {formatDateBE(item.contactDate, "DD/MM/YYYY")}
                              </Text>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item
                              label={
                                <Text className="pr_green">ชื่อเจ้าหน้าที่</Text>
                              }
                              name={"name_staff"}
                            >
                              <Text>{item.officerName}</Text>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item
                              label={
                                <Text className="pr_green">สถานะปัจจุบัน</Text>
                              }
                              name={"currentStatus"}
                            >
                              <Text>
                                {
                                  item.currentStatus
                                    ? convertMasterData(
                                        item.currentStatus,
                                        dropDownCurerntStatus == "" ? dropDownCurerntStatus
                                        : dropDownCurerntStatus_v2
                                      )
                                    : "-"
                                }
                              </Text>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row span={16} style={{ paddingTop: 50 }}>
                          <Col span={12}>
                            <Form.Item
                              label={
                                <Text className="pr_green">
                                  รายละเอียดการติดต่อ
                                </Text>
                              }
                              name={"detail_contact"}
                            >
                              <Text>{item.detail}</Text>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row span={16} style={{ paddingTop: 50 }}>
                          <Col span={12}>
                            <Form.Item
                              name={"question_6"}
                              label={<Text className="pr_green">แนบไฟล์</Text>}
                            >
                              <Link
                                onClick={() => DownloadFile(item.filePath)}
                                underline
                              >
                                <PaperClipOutlined style={{ paddingRight: 5 }} />
                                {item.fileName}
                              </Link>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </Col>
              );
            })}
      </Row>
    </Content>
  );
};

export default ContactView;
